import React from "react";
import './RequiredLabel.css';

const RequiredLabel = ({ label, required }) => {
  return (
    <div
      className="required-label-wrapper"
      style={{ display: "inline-flex", alignItems: "center" }}
    >
      {label}
      {required && <span className="required-asterisk">*</span>}
    </div>
  );
};

export default RequiredLabel;
